import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../../_services/admin.service';
import { SelectComponent } from 'ng2-select';
import { SelectCompany } from '../impersonate/selectCompany';
import {Permissions} from '../../../_services/permissions';
import {ACLFeature} from '../../../_models/acl-feature';
import {Router} from '@angular/router';
import { environment } from '../../../..//environments/environment';

@Component({
  selector: 'edit-manageportfolio',
  styleUrls: ['manageportfolio.less'],
  templateUrl: 'manageportfolio.component.html',
})
export class ManageportfolioComponent implements OnInit, OnDestroy {

  companies: Array<SelectCompany> = [];
  selectedCompany: SelectCompany;
  canManagePortfolio: boolean = null;
  canAssumeRole = false;

  environment;

  @ViewChild('possibleUsersDropdown') public ngSelectForUsers: SelectComponent;

  constructor(
    private admin: AdminService,
    private permissions: Permissions,
    private router: Router
  ) {
    this.environment = environment;
  }

  ngOnInit() {

    this.permissions.hasFeature(ACLFeature.ASSUME_ROLE)
      .subscribe((success) => {
        this.canAssumeRole = success;
      });

    this.admin.getCompanies().subscribe((companies) => {
      this.companies = companies.map((item: {id: string, name: string, companyId: number}) => {
        return new SelectCompany(item.id, `${item.name} - ${item.companyId}`);
      });
    });
  }

  onCompanyChange(event) {
    this.selectedCompany = event;
  }

  doAdminister() {
    if (!this.selectedCompany || this.selectedCompany === null) {
      return;
    }

    this.admin.manageCompanyPortfolio(this.selectedCompany.id).subscribe((user) => {
      this.router.navigate(['/']);
    });
  }

  doAdministerInEdit2() {
    window.location.href = environment.API_ENDPOINT + '/management/manage-company-portfolio/edit2/' + this.selectedCompany.id;
  }

  deAdminister() {
    this.admin.deAssumeRole().subscribe((data) => {
      this.router.navigate(['/']);
    });
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/management/components/manageportfolio/manageportfolio.component.ts